import { FormInstance, List } from 'antd';
import { Container, Section, SectionTitle } from '../style';
import { StyledListItem } from '../../../../styles/listItem';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../store';
import {
  fetchTemplateCauses,
  linkCauseToTemplate,
  selectDraftTemplate,
  selectTemplateCurrentCauses,
} from '../../../../slices/templates';
import IssueCard from '../../../../components/issueCard';
import { useEffect } from 'react';
import CauseForm from '../../../../components/causeForm';
import { Cause } from '../../../../types';

const AddCause = ({ form }: { form: FormInstance }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const draftTemplate = useSelector(selectDraftTemplate);
  const causes = useSelector(selectTemplateCurrentCauses);

  const handleCancel = () => {};

  const handleSubmit = async (cause: Cause) => {
    dispatch(
      linkCauseToTemplate({
        cause,
      })
    );
  };

  useEffect(() => {
    if (draftTemplate?.templateID) {
      dispatch(fetchTemplateCauses({ templateId: draftTemplate.templateID }));
    }
  }, []);

  return (
    <Container>
      <SectionTitle>Add New Cause</SectionTitle>
      <Section>
        <CauseForm
          templateID={String(draftTemplate?.templateID)}
          form={form}
          onSubmit={handleSubmit}
        />
      </Section>
      {causes?.length ? (
        <>
          <p>Causes ({causes?.length})</p>
          <Section>
            <List>
              {causes.map((i) => (
                <StyledListItem key={i.causeID}>
                  <IssueCard issue={i}></IssueCard>
                </StyledListItem>
              ))}
            </List>
          </Section>
        </>
      ) : null}
    </Container>
  );
};

export default AddCause;
